import { AppState, AppThunkDispatch } from '../..';
import AssetDeviceConfiguration from '../../../services/asset-device-configuration';
import { enqueueSnackbarAction } from '../../snackbar/actions';
import { ConfigurationActionNames } from './types';

export const getAssetDeviceConfiguration =
  (input: any) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const assetDeviceConfiguration = new AssetDeviceConfiguration(
      client,
      envVariables.assetDeviceConfigV2BaseUrl,
    );
    try {
      const response = await assetDeviceConfiguration.getConfigurationForAsset(input);
      dispatch({
        type: ConfigurationActionNames.SET_DEVICE_CONFIGURATION,
        payload: response?.data?.configs[0],
      });
    } catch (error) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Failed to Retrieve Configuration',
          options: {
            variant: 'error',
          },
        }),
      );
    }
  };
export const postAssetDeviceConfiguration =
  (input: any) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const assetDeviceConfiguration = new AssetDeviceConfiguration(
      client,
      envVariables.assetDeviceConfigV2BaseUrl,
    );
    try {
      const response = await assetDeviceConfiguration.queueAssetDeviceConfiguration(input);
      const data = response?.data?.configs[0];
      if (response.status === 200) {
        dispatch({
          type: ConfigurationActionNames.SET_DEVICE_CONFIGURATION,
          payload: {
            endofDayReportTime: {
              desiredSetting: {
                endOfDay: data?.endofDayReportTime?.endOfDay,
              },
            },
            locator: {
              desiredSetting: {
                reportingInterval: data?.locator?.reportingInterval,
                lowTempThreshold: data?.locator?.lowTempThreshold,
                highTempThreshold: data?.locator?.highTempThreshold,
                motionDetectionThreshold: data?.locator?.motionDetectionThreshold,
                enableMotionDetect: data?.locator?.enableMotionDetect,
              },
            },
          },
        });
        dispatch(
          enqueueSnackbarAction({
            message: 'Saved',
            options: {
              variant: 'success',
            },
          }),
        );
      }
    } catch (error) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Failed to Update',
          options: {
            variant: 'error',
          },
        }),
      );
    }
  };
